import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { ProvinceApi } from "../data/apis/ProvinceApi";

export function provinceDataSource() {
    const api = new ProvinceApi(apiConfiguration);

    return new CustomStore({
        key: "codice",
        loadMode : 'raw',
        load: (loadOptions) => api.getProvince(),
        
        byKey: (key) => api.getProvinciaById({codice:key})
    });
}